import {
    AfterViewInit,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { DxScrollViewComponent } from 'devextreme-angular/ui/scroll-view';

@Component({
    selector: 'app-entity-carousel',
    templateUrl: './entity-carousel.component.html',
    styleUrl: './entity-carousel.component.scss'
})
export class EntityCarouselComponent implements AfterViewInit, OnChanges {

    @Input() title: string = '';
    @Input() items: any[] = [];
    @Input() actionText?: string;
    @Input() actionIcon?: string;
    @Input() isBusy: boolean = false;
    @Input() placeholderCount: number = 2;

    @Output() actionClick = new EventEmitter<void>();

    @ContentChild('cardTemplate') cardTemplate!: TemplateRef<any>;
    @ContentChild('listTemplate') listTemplate!: TemplateRef<any>;

    @ViewChild('scrollView') scrollView!: DxScrollViewComponent;

    viewTypeCards: boolean = true;
    showBackButton: boolean = false;
    showForwardButton: boolean = false;

    private viewInitialized = false;

    get visible(): boolean {
        return this.isBusy || this.items.length > 0;
    }

    get showPlaceholders(): boolean {
        return this.isBusy && this.items.length === 0;
    }

    ngAfterViewInit(): void {
        this.viewInitialized = true;
        setTimeout(() => this.updateScrollButtons(), 0);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['items'] && this.viewInitialized) {
            setTimeout(() => this.updateScrollButtons(), 0);
        }
    }

    viewAsCards(): void {
        this.viewTypeCards = true;
        setTimeout(() => this.updateScrollButtons(), 0);
    }

    viewAsList(): void {
        this.viewTypeCards = false;
    }

    scrollLeft(): void {
        this.scrollBy(-300);
    }

    scrollRight(): void {
        this.scrollBy(300);
    }

    updateScrollButtons(): void {
        if (!this.scrollView?.instance) return;
        const scrollWidth = this.scrollView.instance.scrollWidth();
        const clientWidth = this.scrollView.instance.clientWidth();
        const leftOffset = this.scrollView.instance.scrollLeft();
        this.showBackButton = leftOffset > 0;
        this.showForwardButton = leftOffset + clientWidth < scrollWidth;
    }

    private scrollBy(distance: number): void {
        const nativeScrollDiv = this.scrollView?.instance
            ?.element()
            ?.querySelector('.dx-scrollable-container');
        nativeScrollDiv?.scrollBy({ left: distance, behavior: 'smooth' });
    }
}
